export {default} from './SetTranscriptStatusPromiseModal'
